<template>
  <div
    ref='root'
    v-show='visible'
    class='popup quotation'
  >
    <div class='content'>
      <p>見積書の作成</p>
      <div class='form'>
        <ul>
          <li>
            <label for='name'>宛先名</label>
            <input v-model='name' type='text' id='name' name='name' placeholder='例) VUILD株式会社' required />
          </li>
          <li>
            <label for='postal-code'>郵便番号</label>
            <input v-model='postalCode' type='text' id='postal-code' name='postal-code' placeholder='例) 210-0024' autocomplete='postal-code' required />
          </li>
          <li class='address'>
            <label for='address'>住所</label>
            <textarea v-model='address' id='address' name='address' placeholder='例) 神奈川県川崎市川崎区日進町3-4 UNICO 1F-A'></textarea>
          </li>
          <li>
            <label for=''></label>
            <div class='button-wrapper'>
              <a class='button cancel' @click.prevent.stop='cancel'>キャンセル</a>
              <a class='button download' @click.prevent.stop='download'>作成</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import PopupBase from './PopupBase.vue';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import koruriFontInstaller from '../assets/fonts/Koruri-Regular-normal';

import CostItem from '../assets/javascripts/CostItem';
import { formatPrice } from '../assets/javascripts/Formatter';

import hankoPng from '../assets/images/hanko.png';

// 見積書のデザイン
// https://docs.google.com/presentation/d/12B5uZkfJKLPH-PCW1Sv_GyfjnXHMmbd7lb-Ed-Y_4aw/edit#slide=id.g8267cddb77_0_0

export default {
  name: 'QuotationPopup',
  extends: PopupBase,
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    costItems: {
      type: Array,
      default: () => { return []; }
    },
    cost: {
      type: Object,
      default: () => { return {}; }
    }
  },
  data () {
    return {
      name: '',
      postalCode: '',
      address: ''
    };
  },
  mounted () {
  },
  methods: {
    create (id = '30213110') {
      // eslint-disable-next-line new-cap
      const doc = new jsPDF();
      // const doc = new jsPDF('p', 'pt', 'a4', true)

      koruriFontInstaller(doc);
      doc.setFont('Koruri-Regular', 'normal');

      const width = 210;

      doc.setFontSize(22);
      doc.text('見積書', 105, 20, null, null, 'center');

      let y1 = this.addTextLines({
        doc: doc,
        lines: [
          this.name,
          `〒${this.postalCode}`,
          this.address
        ],
        textWidth: 60,
        xPosition: 10,
        initialYPosition: 40,
        fontSize: 13
      });

      doc.addImage(hankoPng, 'png', 170, 35, 30, 30);

      let y2 = this.addTextLines({
        doc: doc,
        lines: [
          'VUILD株式会社',
          '〒243-0806',
          '神奈川県厚木市下依知１丁目７−２４'
        ],
        textWidth: 80,
        xPosition: 120,
        initialYPosition: 40,
        fontSize: 13,
        textAlign: 'left'
      });

      let cursorY = Math.max(y1, y2) + 7;

      let today = new Date();
      let expired = new Date();
      expired.setDate(today.getDate() + 30);

      cursorY = this.addTextLines({
        doc: doc,
        lines: [
          `見積書番号: ${id}`,
          `発行日: ${this.dateFormat(today)}`,
          `有効期限: ${this.dateFormat(expired)}`
        ],
        textWidth: 180,
        xPosition: 10,
        initialYPosition: cursorY,
        fontSize: 13
      });

      let subTotal = this.cost.total_cost;
      let tax = this.cost.total_cost_tax - subTotal;
      let total = subTotal + tax;

      cursorY += 20;

      doc.text(`御見積金額 ${formatPrice(total)}`, 10, cursorY);
      cursorY += 7;

      doc.autoTable({
        startY: cursorY,
        margin: {
          top: 0,
          left: 10,
          right: 10,
          bottom: 0
        },
        styles: {
          font: 'Koruri-Regular',
          fontSize: 12,
          fontStyle: 'normal'
        },
        headStyles: {
          font: 'Koruri-Regular',
          fontStyle: 'normal'
        },
        head: [[
          '品目',
          '単価',
          '数量',
          '単位',
          '価格'
        ]],
        body: this.costItems.map(item => item.row()).concat([
          ['送料', '', '', '', '別途見積もり']
        ]),
      });

      cursorY = doc.autoTable.previous.finalY + 10;

      doc.text(`小計`, 140, cursorY, null, null, 'left');
      doc.text(`${formatPrice(subTotal)}`, 200, cursorY, null, null, 'right');

      cursorY += 7;
      doc.text(`消費税`, 140, cursorY, null, null, 'left');
      doc.text(`${formatPrice(tax)}`, 200, cursorY, null, null, 'right');

      cursorY += 7;
      doc.text(`合計`, 140, cursorY, null, null, 'left');
      doc.text(`${formatPrice(total)}`, 200, cursorY, null, null, 'right');

      cursorY += 20;

      doc.setFontSize(14);
      doc.text('備考', 10, cursorY);

      cursorY += 7;

      this.addTextLines({
        doc: doc,
        lines: [
          'ここに記載されている金額はあくまでも概算であり、正式な発注はメール等のやり取りでの本見積を経て最終的に行われます。その際、当初の見積から金額が変動する場合があります。',
          '加工した製品の配送に関わる費用は含まれていません。'
        ].map(text => `・${text}`),
        textWidth: 190,
        xPosition: 10,
        initialYPosition: cursorY,
        fontSize: 12,
        lineSpacing: 6
      });

      return doc;
    },
    addTextLines ({doc, lines, textWidth = 80, textAlign = 'left', fontSize = 14, lineSpacing = 7, xPosition = 10, initialYPosition = 10}) {
      let cursorY = initialYPosition;
      lines.forEach(line => {
        cursorY = this.addWrappedText({
          doc: doc,
          text: line,
          textWidth: textWidth,
          textAlign: textAlign,
          fontSize: fontSize,
          lineSpacing: lineSpacing,
          xPosition: xPosition,
          initialYPosition: cursorY
        });
      });
      return cursorY;
    },
    addWrappedText ({doc, text, textWidth, textAlign = 'left', fontSize = 10, lineSpacing = 7, xPosition = 10, initialYPosition = 10, pageWrapInitialYPosition = 10}) {
      doc.setFontSize(fontSize);

      let textLines = doc.splitTextToSize(text, textWidth); // Split the text into lines
      let pageHeight = doc.internal.pageSize.height; // Get page height, we'll use this for auto-paging. TRANSLATE this line if using units other than `pt`
      let cursorY = initialYPosition;

      textLines.forEach(lineText => {
        if (cursorY > pageHeight) { // Auto-paging
          doc.addPage();
          cursorY = pageWrapInitialYPosition;
        }
        doc.text(lineText, xPosition, cursorY, null, null, textAlign);
        cursorY += lineSpacing;
      });

      return cursorY;
    },
    dateFormat (date) {
      let year = date.getUTCFullYear();
      let month = date.getUTCMonth() + 1;
      let day = date.getUTCDate();
      return `${year}/${month}/${day}`;
    },
    clearItems () {
      this.costItems = [];
    },
    addItem (name, unitPrice, amount, unit) {
      this.costItems.push(new CostItem(name, unitPrice, amount, unit));
    },
    format (price) {
      let str = price.toString();
      let arr = str.split('').reverse();

      let len = arr.length;
      let commas = Math.floor(len / 3);

      for (let i = 0; i < commas; i++) {
        let idx = 3 * (i + 1) + i;
        if (idx >= arr.length) break;
        arr.splice(idx, 0, ',');
      }

      return arr.reverse().join('') + '円';
    },
    tax (price) {
      return Math.floor(price * 0.1);
    },
    genRand (length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    getQuotationId () {
      // 見積書の番号は、冒頭に本見積でないことを示す「1」+ EMARFの「E」+「年月日6桁（200308など）」+ 4桁のランダムな文字列 + - project id
      // by Shori Hamadaさん
      let today = new Date();
      let year = today.getUTCFullYear();
      let month = today.getUTCMonth() + 1;
      let day = today.getUTCDate();

      return `1E${year}${this.pad(month)}${this.pad(day)}${this.genRand(4)}-${this.projectId}`;
    },
    pad (num) {
      return ('00' + num).slice(-2);
    },
    cancel () {
      this.hide();
    },
    download () {
      let id = this.getQuotationId();
      let doc = this.create(id);
      doc.save(`${id}.pdf`);
    },
    debug (doc) {
      let iframe = document.createElement('iframe');
      iframe.setAttribute('style', 'position:absolute;right:0; top:0; bottom:0; height:100%; width:500px');
      document.body.appendChild(iframe);
      iframe.src = doc.output('datauristring');
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/QuotationPopup.vue